// Shopify Sticky Cart Bar Component
class StickyCartBar {
   constructor() {
       this.stickyBar = document.getElementById('stickyCartBar');
       this.mainButton = document.querySelector('.product-form__submit');
       this.stickyButton = document.getElementById('stickyAddToCart');
       this.chatLauncher = null;
       this.isVisible = false;
       
       this.init();
   }

   init() {
       // Set up scroll listener
       window.addEventListener('scroll', this.handleScroll.bind(this));
       
       // Set up click handler for sticky button
       this.stickyButton.addEventListener('click', this.scrollToMainForm.bind(this));
       
       // Try to find chat launcher with multiple attempts
       this.findChatLauncher();
       
       // Initial check
       this.handleScroll();
   }

   findChatLauncher() {
       // Try multiple selectors and wait for element to be available
       const selectors = [
           'iframe#launcher',
           '#launcher',
           'iframe[id="launcher"]',
           '[id="launcher"]'
       ];
       
       const tryFind = () => {
           for (let selector of selectors) {
               this.chatLauncher = document.querySelector(selector);
               if (this.chatLauncher) {
                   console.log('Found chat launcher:', this.chatLauncher);
                   return true;
               }
           }
           return false;
       };
       
       // Try immediately
       if (!tryFind()) {
           // If not found, try again after a delay
           setTimeout(() => {
               if (!tryFind()) {
                   // Try one more time after longer delay
                   setTimeout(tryFind, 2000);
               }
           }, 500);
       }
   }

   handleScroll() {
       if (!this.mainButton) return;
       
       const mainButtonRect = this.mainButton.getBoundingClientRect();
       const isMainButtonVisible = mainButtonRect.bottom > 0 && 
                                 mainButtonRect.top < window.innerHeight;
       
       // Only show sticky bar if user has scrolled past the add to cart button
       const hasScrolledPastButton = mainButtonRect.top < 0;
       
       if (hasScrolledPastButton && !isMainButtonVisible && !this.isVisible) {
           this.showStickyBar();
       } else if ((isMainButtonVisible || !hasScrolledPastButton) && this.isVisible) {
           this.hideStickyBar();
       }
   }

   showStickyBar() {
       this.stickyBar.classList.add('visible');
       this.isVisible = true;
       
       // Move chat launcher up when sticky bar is visible
       this.updateChatLauncherPosition('50px');
   }

   hideStickyBar() {
       this.stickyBar.classList.remove('visible');
       this.isVisible = false;
       
       // Reset chat launcher position to bottom when sticky bar is hidden
       this.updateChatLauncherPosition('0');
   }

   updateChatLauncherPosition(bottomValue) {
       // Try to find launcher if we don't have it yet
       if (!this.chatLauncher) {
           this.findChatLauncher();
       }
       
       if (this.chatLauncher) {
           this.chatLauncher.style.bottom = bottomValue;
           console.log('Updated chat launcher bottom to:', bottomValue);
       } else {
           console.log('Chat launcher not found');
       }
   }

   scrollToMainForm(event) {
       event.preventDefault();
       
       if (this.mainButton) {
           this.mainButton.scrollIntoView({
               behavior: 'smooth',
               block: 'center'
           });
       }
   }

   // Method to update product info dynamically
   updateProductInfo(title, price) {
       const titleElement = this.stickyBar.querySelector('.sticky-product-title');
       const priceElement = this.stickyBar.querySelector('.sticky-product-price');
       
       if (titleElement) titleElement.textContent = title;
       if (priceElement) priceElement.textContent = price;
   }
}

// Initialize the sticky cart bar when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
   new StickyCartBar();
});